import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query reaonsForPermissionActive {
        reaonsForPermissionActive {
            id
            description
            abbreviated
            type
            is_active
            has_subsidy
            apply_sunday_discount
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query reaonsForPermissionWithPagination ($page: Int, $perPage: Int) {
        reaonsForPermissionWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                description
                abbreviated
                type
                has_subsidy
                apply_sunday_discount
                is_active
                status_text
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createReasonForPermission ($input: CreateReasonForPermissionInput!) {
    createReasonForPermission (input: $input) {
        id
        description
        abbreviated
        type
        is_active
        has_subsidy
        apply_sunday_discount
        status_text
     }
 }
`

const UPDATE = gql`
 mutation updateReasonForPermission ($id: ID!, $input: UpdateReasonForPermissionInput!) {
    updateReasonForPermission (id: $id, input: $input) {
        id
        description
        abbreviated
        type
        is_active
        has_subsidy
        apply_sunday_discount
        status_text
     }
 }
`

const CHANGE_STATUS = gql`
 mutation updateReasonForPermission ($id: ID!, $input: UpdateReasonForPermissionInput!) {
    updateReasonForPermission (id: $id, input: $input) {
        id
        description
        abbreviated
        type
        is_active
        has_subsidy
        apply_sunday_discount
        status_text
     }
 }
`

const DELETE = gql`
 mutation deleteReasonForPermission ($id: ID!) {
    deleteReasonForPermission (id: $id) {
        id
        description
        abbreviated
        type
        is_active
        has_subsidy
        apply_sunday_discount
        status_text
     }
 }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
